<p-chart type="bubble" [data]="bubbleChartData" [options]="bubbleChartOptions"></p-chart>
